import PropTypes from 'prop-types';

export const propTypes = {
  authentication: PropTypes.object.isRequired,
  msisdn: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  confirmPhoneNumber: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func,
  updateContactsInfo: PropTypes.func.isRequired,
};
